<template lang="pug">
  section
    b-container
      h4.mt-0(v-if="this.piece") {{ piece.title }}
      b-button.mb-3(:to="{name: 'Art'}")
        font-awesome-icon.mr-2(icon="caret-left")
        span ALL ART
      content-loader(:height="7", v-if="alert.loading")
      b-card(v-else="")
        .container
          .row
            .col-md-6.pl-0
              img.img-main.pointer(:src="getImageUrl(piece.thumbnail_url)", @click='index = 0')
              CoolLightBox(:items='piece.images.map(item => getImageUrl(item.url))' :index='index' @close='index = null')
              b-container.pt-3
                .row
                  .col-md-4.center-xy.px-3.pb-3(v-for='(image, imageIndex) in piece.images.map(item => item.url)', :key='imageIndex')
                    div.img-small.pointer(@click='index = imageIndex', :style="{'background-image': `url(${getImageUrl(image)})`}")
            .col-md-6
              h2.mt-0 {{ piece.title }}
              p {{ piece.artist }}
              h4.mt-1 {{ `R${piece.price}` }}
              p {{ `${piece.form} | ${piece.medium} | ${piece.style} | ${piece.subject}` }}
              div
                ul.list-unstyled
                  li
                    span.font-weight-bold Framed
                    span.ml-1 {{ piece.framed?'Yes':'No' }}
                  li
                    span.font-weight-bold Size
                    span.ml-1 {{ `${piece.height} x ${piece.width}cm` }}
                  li
                    span.font-weight-bold Ready to hang
                    span.ml-1 {{ piece.ready_to_hang?'Yes':'No' }}
                  li
                    span.font-weight-bold Collection
                    span.ml-1 {{ (piece.stock > 1)?`${piece.stock} copies`:'No' }}
                  li
                    span.font-weight-bold Rentable
                    span.ml-1 {{ piece.is_rentable?`R${piece.price_rental}/m`:'No' }}
                span Materials
                p.mb-1 {{ piece.materials }}
                span Description
                p.mb-1 {{ piece.description }}
                h4.d-inline-block
                div(v-if="piece.status == 'pending'")
                  button-load(:flag="alert.busy", label="APPROVE", classes="btn-outline btn-block", v-on:clicked="approveThisPiece")
                  b-button.btn-clear.btn-block(@click="declineThisPiece") DECLINE
                // b-button.btn-outline.btn-block(v-else="", :disabled="true") {{ piece.status }}
                button-load(v-else="", :flag="alert.busy", label="REMOVE PIECE", classes="btn-outline btn-block", v-on:clicked="deleteArt")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import { mapState, mapActions, mapGetters } from 'vuex';
import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import router from '@/router';

export default {
  name: 'Piece',
  components: {
    ContentLoader,
    CoolLightBox,
  },
  mixins: [standardMix],
  data() {
    return {
      piece: null,
      images: [],
      index: null,
    };
  },
  computed: {
    ...mapState('resource', ['art_forms', 'art_media', 'art_styles', 'art_subjects']),
    ...mapGetters('resource', ['getArtMedia']),
  },
  methods: {
    ...mapActions('art', ['addArt', 'updateArt']),
    async approveThisPiece() {
      try {
        this.busy();
        await apiService.approvePiece(this.piece.id);
        this.piece.status = 'available';
        this.success('Piece approved');
      } catch (error) {
        this.error('Could not approve piece at this time');
      }
    },
    async declineThisPiece() {
      try {
        this.busy();
        await apiService.declinePiece(this.piece.id);
        this.piece.status = 'declined';
        this.success('Piece declined');
      } catch (error) {
        this.error('Could not decline piece at this time');
      }
    },
    async deleteArt() {
      try {
        this.busy();
        await apiService.deletePiece(this.piece.id);
        router.push({ name: 'Art' });
      } catch (error) {
        this.error('This piece could not be removed');
      }
    },
  },
  async created() {
    if (this.$route.params.pieceId) {
      this.loading();
      this.piece = await apiService.getPiece(this.$route.params.pieceId);
      this.clear();
    }
  },
};
</script>

<style lang="scss" scoped>
  .img-preview {
    width: 100px !important;
  }
  .img-small {
    width: 100px;
    height: 100px;
    background-position: center;
    background-size: cover;
  }
  .img-main {
    width: 100%;
    // max-height: 90vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Piece.vue